import { ButtonBaseProps, FabProps, SxProps, TypographyProps, Theme, ZoomProps } from '@mui/material';

export const subTitleProps: TypographyProps = {
    fontSize: '18px',
    fontWeight: 500,   
}
export const textPayloadProps: TypographyProps = {
    fontSize: '17px',
    fontWeight: 400,   
}

export const MUIScrollbarProps: SxProps = {
    "&::-webkit-scrollbar": {
        width: "10px",
        height: "10px",
    },
    "&::-webkit-scrollbar-track": {
        backgroundColor: "rgba(0, 0, 0, 0.05)",
    },
    "&::-webkit-scrollbar-track:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.1)",
    },
    "&::-webkit-scrollbar-thumb": {
        borderRadius: '9px',
        backgroundClip: 'content-box',
        minHeight: '32px',
        minWidth: '32px',

        // backgroundColor: "#D8D8D8",
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
    },
    "&::-webkit-scrollbar-thumb:hover": {
        // backgroundColor: "#A8A8A8",
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
}

export const glassProps = {
  backdropFilter: 'blur(10px)',
  // backgroundColor: 'rgba(25, 118, 210, 0.1)',
  backgroundColor: 'rgba(25, 118, 210, 0.25)',
}

export const MUIScrollbarRefFnPadding = (ref: React.RefObject<HTMLDivElement>['current'] | undefined | unknown,
    cssObj?: Partial<CSSStyleDeclaration>,
) => {
    if (ref instanceof HTMLElement) {
        if (ref.scrollHeight > ref.clientHeight) {
            ref.style.paddingRight = '8px'
        } else {
            ref.style.paddingRight = '0px'
        }

        if (cssObj) {
            Object.keys(cssObj).forEach((key) => {
                //@ts-ignore
                ref.style[key] = cssObj[key]
            })
        }
    }
}

export const DrawerButtonFabProps: FabProps = {
    variant: 'extended',
    color: 'warning',
    sx: {
        borderRadius: "30px 0 0 30px",
        boxShadow: 0, bgcolor: 'orange',
        pr: '24px', width: '60px',
        height: '48px',
        "&:focus": {
            boxShadow: 0,
        },
    }
}

export const ButtonBaseStyle: ButtonBaseProps = {
  sx: {
    borderRadius: '8px',
    p: '8px',
  },
};

export const ToggleButtonGroupSx: SxProps<Theme> = ({ palette }) => ({
  '.MuiToggleButton-root.Mui-selected': {
    color: palette.primary.contrastText,
    bgcolor: palette.primary.main,
  },
  '.MuiToggleButton-root.Mui-selected:hover': {
    bgcolor: palette.primary.dark,
  },
});


interface ZoomSamePlaceTransitionProps {
  value: number;
  index: number;
  theme: Theme;
}

export const getZoomSamePlaceTransitionProps = ({
  value,
  index,
  theme,
}: ZoomSamePlaceTransitionProps): Partial<ZoomProps> => {
  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen,
  };

  return {
    timeout: transitionDuration,
    style: {
      transitionDelay: `${value === index ? transitionDuration.exit : 0}ms`,
    },
    in: value === index,
    unmountOnExit: true
  };
};